import { ChangeEvent, useState, useEffect } from 'react';
import {
  Divider,
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TableContainer,
  CardContent,
  Container,
  Grid,
  TextField,
  Typography,
  Button,
} from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { debounce } from 'lodash';
import { TableLoader, TableNotFound } from 'src/Utils/TableLoader';
import dayjs from 'dayjs';
import CommonDateRangePicker from 'src/common/CommonDateRangePicker';
import { TOtherIncomeList } from './type/otherIncomeType';
import OtherIncomeTableRow from './OtherIncomeTableRow';
import GetDataApi from 'src/common/FetchData/GetDataApi';
import CreateOtherIncome from './CreateOtherIncome';
import ModalsWrapper from 'src/components/Modals/ModalsWrapper';

const OtherIncome = () => {
  const [limit, setLimit] = useState<number>(25);
  const [open, setOpen] = useState<boolean>(false);
  const [dateRange, setDateRange] = useState<{
    start_date: string;
    end_date: string;
  }>({
    start_date: '',
    end_date: dayjs().format('YYYY-MM-DD'),
  });
  const [refresh, setRefresh] = useState(false);
  const [filterItem, setFilterItem] = useState({
    expense_no: '',
  });
  const [searchParams, setSearchParams] = useSearchParams({
    page: '0',
  });

  const page = parseInt(searchParams.get('page'));

  let uri = `/api/atab/income?CompanyProfileId=1&limit=${limit}&skip=${limit * page}`;
  if (filterItem.expense_no) {
    uri += `&income_no=${filterItem?.expense_no}`;
  }
  if (dateRange?.start_date && dateRange?.end_date) {
    uri += `&start_date=${dateRange?.start_date}&end_date=${dateRange?.end_date}`;
  }
  const { response, getData, loading, total } =
    GetDataApi<TOtherIncomeList[]>(uri);
  useEffect(() => {
    (async function () {
      await getData();
    })();
  }, [page, limit, filterItem.expense_no, dateRange, refresh]);

  const handlePageChange = (_event: any, newPage: number): void => {
    searchParams.set('page', newPage.toString());
    setSearchParams(searchParams);
  };

  const handleLimitChange = (event: ChangeEvent<HTMLInputElement>): void => {
    setLimit(parseInt(event.target.value));
  };

  const handelInputChange = debounce((value: string, key: string) => {
    setFilterItem((prevState: any) => ({
      ...prevState,
      [key]: value,
    }));
  }, 2000);
  return (
    <Container maxWidth='xl'>
      <Grid
        container
        direction='row'
        justifyContent='center'
        alignItems='stretch'
        spacing={3}
      >
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Grid container alignItems={'center'}>
                <Grid item xs={12} sm={12} md={2}>
                  <Typography
                    fontWeight={'bold'}
                    variant='h6'
                    component='h6'
                    gutterBottom
                  >
                    Other Income List
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={10}>
                  <Grid container spacing={1} justifyContent={'end'}>
                    <Grid item xs={12} sm={12} md={3} lg={3} xl={2}>
                      <TextField
                        sx={{ width: '100%' }}
                        label='Search by income no'
                        id='outlined-basic'
                        type='search'
                        size='small'
                        variant='outlined'
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                          handelInputChange(e.target.value, 'expense_no')
                        }
                      />{' '}
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <CommonDateRangePicker
                        setDateRange={setDateRange}
                        dateRange={dateRange}
                      />
                    </Grid>

                    <Grid item xs={12} sm={12} md={3} lg={3} xl={2}>
                      <Button
                        size='medium'
                        onClick={() => setOpen(true)}
                        variant='contained'
                        sx={{ width: '100%' }}
                      >
                        Other Income
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>
            <Divider />

            <CardContent>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>SL</TableCell>
                      <TableCell>Income No</TableCell>
                      <TableCell>Voucher No</TableCell>
                      <TableCell>Date</TableCell>
                      <TableCell>Payment Method</TableCell>
                      <TableCell>Account</TableCell>
                      <TableCell>Amount</TableCell>
                      <TableCell>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {loading ? (
                      <TableLoader />
                    ) : response?.length ? (
                      <>
                        {response?.map((item, index) => (
                          <OtherIncomeTableRow
                            key={item.id}
                            inComeData={item}
                            index={index + 1}
                            isSuccessFun={() => getData()}
                          />
                        ))}
                      </>
                    ) : (
                      <TableNotFound />
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              <Box p={2}>
                <TablePagination
                  component='div'
                  count={total}
                  onPageChange={handlePageChange}
                  onRowsPerPageChange={handleLimitChange}
                  page={page && page}
                  rowsPerPage={limit}
                  rowsPerPageOptions={[25, 50, 75, 100]}
                />
              </Box>
            </CardContent>

            <ModalsWrapper
              modalData={{ title: 'Create other income' }}
              setShowModal={setOpen}
              showModal={open}
            >
              <CreateOtherIncome
                setRefresh={setRefresh}
                handelClose={() => {
                  setOpen(false);
                  getData();
                }}
              />
            </ModalsWrapper>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default OtherIncome;
